import { BudgetProposalT } from 'routes/BudgetModule/config/types';

/**
 * Get common tracking metadatas from a budget proposal
 * @param proposal the budget proposal
 * @returns a dict with the budget name and phase
 */
export const tagFromProposal = (proposal: BudgetProposalT) => ({
    budget: proposal.name,
    phase: proposal.phase,
});
